module.exports = __webpack_public_path__ + "img/good.40bd9dac.png";